// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\UserPermissions\UserPermissionsViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { Role, RoleData, RoleOptions } from 'data/models/Role';

// UserPermissionsResponseData is the class that UserPermissionsResponse serializes to/from
export interface UserPermissionsResponseData {
    OrganizationId : number;
	
    AssignableRoles : RoleData[] | null;
    Users : PCUserData[] | null;
	
}

// UserPermissionsResponseOptions is the class which may be passed to the UserPermissionsResponse constructor to define optional initial data values
export interface UserPermissionsResponseOptions {
    OrganizationId : number;
	
    AssignableRoles? : RoleOptions[] | null;
    Users? : PCUserOptions[] | null;
	
}

export class UserPermissionsResponse {
    public OrganizationId : DataSignal<number>;
	
    public AssignableRoles : SDataArray<Role>;
    public Users : SDataArray<PCUser>;
	

    constructor();
    constructor(data : UserPermissionsResponseOptions);
    constructor(data: UserPermissionsResponseOptions | null = null) {
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
	    
        this.AssignableRoles = SArray<Role>([]);
        this.Users = SArray<PCUser>([]);
	    
    }

    static key(obj : UserPermissionsResponse) {
        return obj.OrganizationId();
    }
    
    static dataKey(obj : UserPermissionsResponseOptions) {
        return obj.OrganizationId;
    }

    static update(obj : UserPermissionsResponse, data : UserPermissionsResponseOptions) {
        S.freeze(() => {
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/UserPermissionsResponse.ts